<section class="card mt-2">
  <div class="card-body">
    <nav class="d-flex flex-wrap mb-3" aria-label="HR Approval">
      <a routerLink="/queues/form-approval" class="btn btn-secondary mr-2 mb-2">Form Approval</a>
      <a routerLink="/uploaddocs/approval-list" class="btn btn-secondary mr-2 mb-2">Upload Approval</a>
      <a routerLink="/queues/hr-employee-changes" class="btn btn-secondary mr-2 mb-2">Employee Changes</a>
      <a routerLink="/uploaddocs/vaccine-list" class="btn btn-secondary mr-2 mb-2">Uploaded Vaccine Information</a>
      <span class="btn btn-primary mb-2" aria-current="page">Insurance Changes <span class="badge badge-light">{{total}}</span></span>
    </nav>
    <h2>Insurance Changes</h2>
    <p>Review completed life-event submissions. Current coverage stays in effect until approval. New Hire and Open Enrollment do not require approval.</p>
    <form (ngSubmit)="load()" class="row mb-3">
      <div class="col-md-5 mb-2">
        <label for="insurance-campus">Campus</label>
        <p-select inputId="insurance-campus" name="campus" styleClass="w-100" [options]="campuses" [(ngModel)]="campusId" [disabled]="loading || saving"></p-select>
      </div>
      <div class="col-md-5 mb-2">
        <label for="insurance-employee">Employee name</label>
        <input id="insurance-employee" name="employee" class="form-control" [(ngModel)]="employee" [disabled]="loading || saving" />
      </div>
      <div class="col-md-2 d-flex align-items-end mb-2"><button class="btn btn-primary" type="submit" [disabled]="loading || saving">Filter</button></div>
    </form>
    <p class="alert alert-danger" role="alert" *ngIf="error">{{error}}</p>
    <p class="alert alert-success" role="status" *ngIf="message">{{message}}</p>
    <p role="status" *ngIf="loading">Loading insurance changes…</p>
    <p *ngIf="!loading && !items.length">No insurance changes awaiting approval in this view.</p>
    <article class="card mb-3" *ngFor="let item of items">
      <div class="card-body">
        <h3>{{item.employee}} <small>{{item.campus}}</small></h3>
        <p>{{item.event}} <span *ngIf="item.eventOther">— {{item.eventOther}}</span><br />
          Event: {{item.eventDate | date:'shortDate'}} · Submitted: {{item.requestedDate | date:'short'}} · Enrollment year: {{item.enrollmentYear}}</p>
        <button type="button" class="btn btn-secondary" (click)="review(item)" [disabled]="saving" [attr.aria-expanded]="selected?.id === item.id">Review selections</button>
        <div *ngIf="selected?.id === item.id" class="mt-3">
          <button type="button" class="btn btn-secondary mb-3" (click)="downloadDocuments(item)" [disabled]="saving">Download signed documents</button>
          <div class="row">
            <div class="col-lg-6" *ngFor="let group of [{label: 'Current coverage', plans: item.current}, {label: 'Proposed coverage', plans: item.proposed}]">
              <h4>{{group.label}}</h4>
              <p *ngIf="!group.plans.length">No selections recorded.</p>
              <div class="border rounded p-2 mb-2" *ngFor="let selection of group.plans">
                <strong>{{selection.type}}: {{selection.plan}}</strong>
                <p class="mb-1">{{selection.coverage}}<br />{{selection.start | date:'shortDate'}} – {{selection.end ? (selection.end | date:'shortDate') : 'No end date'}}</p>
                <p class="mb-1" *ngIf="selection.costPerPayPeriod != null">Cost per pay period: {{selection.costPerPayPeriod | currency}}</p>
                <p class="mb-1" *ngIf="selection.dependents?.length">Dependents: {{selection.dependents.join(', ')}}</p>
              </div>
            </div>
          </div>
          <label [for]="'insurance-note-' + item.id">Explanation to employee (required for rejection)</label>
          <textarea [id]="'insurance-note-' + item.id" class="form-control mb-2" rows="3" maxlength="2000" [(ngModel)]="note" [disabled]="saving"></textarea>
          <button type="button" class="btn btn-success mr-2 mb-2" (click)="decide(true)" [disabled]="saving">Approve completed changes</button>
          <button type="button" class="btn btn-danger mb-2" (click)="decide(false)" [disabled]="saving || !note.trim()">Reject with explanation</button>
          <p *ngIf="saving" role="status">Saving decision…</p>
        </div>
      </div>
    </article>
    <div class="d-flex flex-wrap align-items-center" *ngIf="total > 20">
      <button type="button" class="btn btn-secondary mr-2" [disabled]="!first || loading || saving" (click)="load(first - 20)">Previous</button>
      <span class="mr-2">{{first + 1}}–{{first + items.length}} of {{total}}</span>
      <button type="button" class="btn btn-secondary" [disabled]="first + 20 >= total || loading || saving" (click)="load(first + 20)">Next</button>
    </div>
  </div>
</section>
